import React, { useState } from "react";
import hostProfileDetailBg from "assets/images/others/attendee-side-images/hostProfileDetailBg.png";
import profilePic from "assets/images/others/host-side-images/attende1.png";
import { ReactComponent as Star } from "assets/images/svgs/attendee/attende-star.svg";
import { ReactComponent as FavouriteChart } from "assets/images/svgs/attendee/attende-favorite-chart.svg";
import { ReactComponent as User } from "assets/images/svgs/attendee/attende-profile-2user.svg";
import BadgeImg from "assets/images/others/attendee-side-images/badge-1.png";
import { MdOutlineStar } from "react-icons/md";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "components/breadcrumbs/AttendeeBreadcrumb";
import { siteRoutes } from "utils/helpers/enums/routes";
import Overview from "./component/Overview";
import Experiences from "./component/Experiences";
import CupOfGratitude from "./component/CupOfGratitude";
import Reviews from "./component/Reviews";
import RsvpBreadcrumb, { RsvpBreadcrumbLink } from "components/breadcrumbs/RsvpBreadcrumb";

interface Tab {
  name: string;
  component: JSX.Element;
}

const tabs: Tab[] = [
  { name: "Overview", component: <Overview /> },
  { name: "Experiences", component: <Experiences /> },
  { name: "Cup of Gratitude", component: <CupOfGratitude /> },
  { name: "Reviews", component: <Reviews/> },
];

const RsvpHostProfileDetail = () => {
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);

  const breadcrumbLinks: RsvpBreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.rsvpHome },
    { title: "Experiences ", path: siteRoutes.rsvpExperiences },
    { title: "Experience Detail ", path: siteRoutes.rsvpExperiencesDetail },
    { title: "Host Profile", path: siteRoutes.rsvpHostProfileDetail },
  ];
  return (
    <div>
      <div
        style={{ backgroundImage: `url(${hostProfileDetailBg})` }}
        className="bg-cover bg-center bg-no-repeat h-full md:h-[280px] w-full"
      >
        <div className=" h-full ">
          <div className="container">
            <RsvpBreadcrumb links={breadcrumbLinks} />
          </div>
        </div>
      </div>
      <div className="container md:mt-[-145px]">
        <div className="flex justify-between flex-wrap  items-center">
          <div className="flex items-end gap-4">
            <img
              className="w-36 h-36 object-cover border-4 border-white rounded-full"
              src={profilePic}
              alt="profilePic"
            />
            <span className="text-3xl text-blackie flex items-end gap-2 font-semibold mb-4">
              Steve Johnson{" "}
              <p className="text-lg text-primaryBlueText font-sm mb-0">
                {" "}
                Alpha Enterprises
              </p>
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-1 bg-yellowBg rounded-lg lg:rounded-full px-3 py-2 mt-6 text-sm">
              <span className="text-yellowText">
                <MdOutlineStar />
              </span>
              <span className="text-yellowText">
                <MdOutlineStar />
              </span>
              <span className="text-yellowText">
                <MdOutlineStar />
              </span>
              <span className="text-yellowText">
                <MdOutlineStar />
              </span>
              <span className="text-yellowText">
                <MdOutlineStar />
              </span>
              <span className="">(5.0)</span>
            </div>
            <div className="w-[210px] h-[230px] rounded-xl bg-white flex flex-col items-center justify-center gap-2 p-4">
              <img src={BadgeImg} alt="BadgeImg" />
              <span className="text-base text-blackie font-medium">
                Member for 1 year
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="container min-h-screen">
        <div className=" flex gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`px-4 py-2 rounded-lg text-white transition-colors duration-300 ${
                activeTab.name === tab.name
                  ? "bg-lightBlueColor"
                  : "bg-grayText "
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className="mt-4">{activeTab.component}</div>
      </div>
    </div>
  );
};

export default RsvpHostProfileDetail;
